import React from "react";
import HomepageTrendingContainer from "./views/homepage-trending-container";

function HomepageTrendingHomePage() {
  return <HomepageTrendingContainer />;
}

export default HomepageTrendingHomePage;
